import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadManager } from '../../../../managers/upload.manager';
import { Upload } from '../../../../models/ui/upload.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../../base.component';

@Component({
    selector: 'lex-edit-upload',
    templateUrl: './edit-upload.component.html',
    styleUrls: ['./edit-upload.component.scss'],
    standalone: false
})
export class EditUploadComponent extends BaseComponent {
	public currentUpload: Upload;
	public uploadFormGroup: UntypedFormGroup;

	constructor(
		private activatedRoute: ActivatedRoute,
		private uploadManager: UploadManager,
		private fb: UntypedFormBuilder,
		private router: Router
	) {
		super();
		const id = this.activatedRoute.snapshot.params.id;
		this.uploadManager.getUpload(id).subscribe((upload) => {
			this.currentUpload = upload;
			this.initializeForm(upload);
		});
	}

	public cancel(): void {
		this.router.navigate(['/', 'case', 'uploads']);
	}

	public save(): void {
		this.uploadManager.updateUpload(this.currentUpload).subscribe(() => {
			this.router.navigate(['/', 'case', 'uploads']);
		});
	}

	public isSaveDisabled(): boolean {
		return this.uploadFormGroup.invalid || this.uploadFormGroup.pristine;
	}

	private initializeForm(upload: Upload): void {
		this.uploadFormGroup = this.fb.group({
			title: [upload.title, [Validators.required]],
			comments: [upload.comments]
		});

		this.uploadFormGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((newValue) => {
			this.currentUpload.title = newValue.title;
			this.currentUpload.comments = newValue.comments;
		});
	}
}
